<template>
  <div class="agree-content policy">
    <table border="1">
      <tr>
        <th style="width: 40%;">제공받는 자 (연락처)</th>
        <td>㈜카카오 (1577-3754)</td>
      </tr>
      <tr>
        <th>제공받는 자가 소재하는 국가</th>
        <td>한국</td>
      </tr>
      <tr>
        <th>제공받는 자의 개인정보 이용목적</th>
        <td>카카오채널 제공</td>
      </tr>
      <tr>
        <th>제공하는 개인정보의 항목</th>
        <td>성명, 소속 기관명(약국,병원명), 휴대전화번호, 이메일주소, 네트워크 이용 기록</td>
      </tr>
      <tr>
        <th>제공받는 자의 개인정보 보유 및 이용기간</th>
        <td><u>개인정보 이용목적을 달성할 때까지</u></td>
      </tr>
    </table>
    <table border="1">
      <tr>
        <th style="width: 40%;">제공받는 자 (연락처)</th>
        <td>지피랩㈜ (02-2006-0862)</td>
      </tr>
      <tr>
        <th>제공받는 자가 소재하는 국가</th>
        <td>한국</td>
      </tr>
      <tr>
        <th>제공받는 자의 개인정보 이용목적</th>
        <td>카카오채널 운영지원</td>
      </tr>
      <tr>
        <th>제공하는 개인정보의 항목</th>
        <td>성명, 소속 기관명(약국,병원명), 휴대전화번호, 이메일주소, 네트워크 이용 기록</td>
      </tr>
      <tr>
        <th>제공받는 자의 개인정보 보유 및 이용기간</th>
        <td><u>개인정보 이용목적을 달성할 때까지</u></td>
      </tr>
    </table>
    <p>
      귀하는 위와 같은 개인정보의 제3자 제공을 거부할 수 있습니다. 다만, 개인정보의 제3자 제공에 동의하지 않을 경우 회사가 위에 명시한 서비스 및 정보제공이 제한될 수 있습니다.
      <br/>
      본인은 회사의 일반 개인정보의 제3자 제공에 관한 설명을 이해하고 이에 동의합니다.
    </p>
    <br/>
  </div>
</template>

<script>
export default {};
</script>
